import Request from '../Request'
export default class EditInvoice extends Request {
  constructor (config) {
    super()
    this.method = 'put'
    this.route = config.route
    this.invoice = config.invoice
    this.newInvoiceNumber = config.newInvoiceNumber
    this.validate()
  }

  id () {
    return this.invoice.id
  }

  label () {
    return this.invoice.invoice_number
  }

  validate () {
    if (this.newInvoiceNumber === null) {
      this.isValid = false
      this.status = 'Skip'
      this.errorMessage = 'New invoice number is not valid!'
    } else {
      this.isValid = true
    }
  }

  json () {
    return { invoice_number: this.newInvoiceNumber }
  }

  endpoint () {
    return this.route + '/invoices/' + this.id() + '/'
  }

  errorHandler (errors) {
    return errors[0]
  }
}
